<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-popup
      title="Activation par lot des utilisateurs"
      :active.sync="bashActivatePrompt"
    >
      <div class="container">
        <div class="row justify-content-md-center">
          <div>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
            >
              <p>
                Activation par lot en cours. Un mail vous sera envoyé une foi
                l'opération terminée.
              </p>
            </vs-col>

            <vs-button
              color="primary"
              class="mt-2"
              type="border"
              size="small"
              @click="togglebashActivatePrompt()"
              >Fermer
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
    <div class="vx-row" v-if="!hasAccess">
      <div class="vx-col w-full">
        <h1 class="text-danger" justify="center" align="center">
          Vous n'avez pas accès à cette liste
        </h1>
      </div>
    </div>
    <div v-else>
      <div class="vx-row">
        <div class="vx-col w-full lg:w-2/3">
          <vs-card>
            <h6 class="font-bold">Sélectionnez le pack de formation</h6>
            <div class="left-card-container">
              <div class="flex-item-left">
                <p class="label text-black mt-2">Pack de formation</p>
                <v-select
                  class="w-full"
                  label="title"
                  placeholder="Selectionner"
                  :options="pack_trainings"
                  v-model="selectedPack"
                >
                  <template slot="spinner" v-if="pack_trainings.length == 0">
                    <div>
                      <svg class="spinner" viewBox="0 0 50 50">
                        <circle
                          class="path"
                          cx="25"
                          cy="25"
                          r="20"
                          fill="none"
                          stroke-width="5"
                        ></circle>
                      </svg>
                    </div>
                  </template>
                </v-select>
              </div>
              <div class="flex-item-right pt-8 ml-2">
                <vs-button
                  @click="certifiedUsers()"
                  :disabled="
                    selectedPack.is_beginner_pack == '1' ? false : true
                  "
                  class="activate-button text-dark font-bold"
                  color="black"
                  size="small"
                  >Activer les certifiés</vs-button
                >
                <vs-button
                  @click="Export()"
                  :disabled="
                    selectedPack.slug && users.length > 0 ? false : true
                  "
                  size="small"
                  :color="$store.state.aa_button_color"
                  class="font-bold ml-1 export-button text-dark"
                  >Exporter</vs-button
                >
              </div>
            </div>
          </vs-card>
        </div>
        <div class="vx-col w-full lg:w-1/3">
          <vs-card>
            <h6 class="font-bold">Total Certifés</h6>
            <p class="mt-3 stats-block font-bold">
              {{ selectedPack.total_users.certified }} /
              {{ selectedPack.total_users.in_team }} Agents
            </p>
          </vs-card>
        </div>
      </div>
      <vs-table ref="table" :data="users">
        <template slot="thead">
          <vs-th>Nom</vs-th>
          <vs-th>Prénom</vs-th>
          <vs-th>N° Téléphone</vs-th>
          <vs-th>Moyenne obtenue</vs-th>
          <vs-th>Date de composition</vs-th>
          <vs-th v-if="selectedPack.is_beginner_pack == '1'">Statut</vs-th>
          <vs-th width="10%" v-if="selectedPack.is_beginner_pack == '1'"
            >Action</vs-th
          >
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td> {{ tr.lastname }}</vs-td>
              <vs-td> {{ tr.firstname }}</vs-td>
              <vs-td> {{ tr.phone }}</vs-td>
              <vs-td> {{ tr.avg }} %</vs-td>
              <vs-td> {{ convertDate(tr.created_at) }}</vs-td>
              <vs-td
                v-if="selectedPack.is_beginner_pack == '1'"
                class="font-bold"
                :class="tr.status == '0' ? 'no-active' : 'is-active'"
              >
                {{ tr.status == "0" ? "Inactif" : "Actif" }}</vs-td
              >

              <vs-td
                class="whitespace-no-wrap"
                v-if="selectedPack.is_beginner_pack == '1'"
              >
                <div class="flex">
                  <div
                    @click="certifiedUsers(tr)"
                    v-if="tr.status == '0'"
                    class="flex font-bold"
                    :class="tr.status == '0' ? 'activate-action' : ''"
                  >
                    <feather-icon
                      icon="CheckIcon"
                      svgClasses="w-5 h-5 stroke-current"
                      class="mr-2"
                    />
                    Activer
                  </div>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-1"
        v-if="last_page && page"
        :total="last_page"
        v-model="page"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import { _buildQuery } from "../../../helpers/buildquery";
import moment from "moment";

export default {
  name: "packListCertifiedUsers",
  data() {
    return {
      selectedPack: {
        title: "",
        slug: "",
        is_beginner_pack: 0,
        total_users: {
          in_team: 0,
          certified: 0,
        },
      },
      page: 1,
      last_page: null,
      pack_trainings: [],
      users: [],
      bashActivatePrompt: false,
    };
  },
  watch: {
    page(value) {
      this.loadPackCertifiedUsers(value);
    },
    "selectedPack.slug": function (value) {
      this.users = [];
      if (value) {
        this.loadPackCertifiedUsers();
      } else {
        this.selectedPack = {
          title: "",
          slug: "",
          is_beginner_pack: 0,
          total_users: 0,
        };
      }
    },
  },
  computed: {
    hasAccess() {
      let settings = localStorage.getItem("settings");
      settings = settings ? JSON.parse(settings) : null;
      if (settings) {
        if (
          settings.pack_certified_users_authorization.includes(
            this.$store.state.AppActiveUser.id
          )
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
  methods: {
    convertDate(date) {
      moment.locale("fr");
      return moment(date).format("DD MMMM YYYY");
    },
    togglebashActivatePrompt(val = false) {
      this.bashActivatePrompt = val;
    },
    async certifiedUsers(item) {
      try {
        let users = [];
        if (item) {
          if (
            item.status == "0" ||
            (item.status == "1" && item.is_certified == "0")
          ) {
            users.push({
              slug: item.user_id,
              lastname: item.lastname,
              firstname: item.firstname,
              phone: item.phone,
            });
          }
        } else {
          this.users.forEach((user) => {
            if (
              user.status == "0" ||
              (user.status == "1" && user.is_certified == "0")
            ) {
              users.push({
                slug: user.user_id,
                lastname: user.lastname,
                firstname: user.firstname,
                phone: user.phone,
              });
            }
          });
        }
        let infos = {
          pack: this.selectedPack.slug,
          users: users,
        };
        if (users.length > 0) {
          this.$vs.loading();
          let response = await this.$http.post(
            "trainings-pack/bash-activate-certified-users",
            infos
          );
          if (response.data) {
            this.togglebashActivatePrompt(true);
            this.$vs.loading.close();
          }
        } else {
          this.$vs.notify({
            title: "Succès",
            text: "Tous les utilisateurs sont actifs et certifiés.",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right",
          });
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erreur",
          text: error.response.data.message
            ? error.response.data.message
            : "Veuillez contacter l'administrateur",
          color: "danger",
          position: "top-right",
        });
      }
    },
    async Export() {
      try {
        const params = {
          pack: this.selectedPack.slug,
        };
        this.$vs.loading();

        const response = await this.$http({
          url: "/trainings-pack/export-certified-users" + _buildQuery(params),
          method: "GET",
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "certified_users_" + this.selectedPack.title + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        this.$vs.loading.close();
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
      }
    },
    async loadPackCertifiedUsers() {
      try {
        this.$vs.loading();
        let params = {
          page: this.page,
          limit: 10,
          pack: this.selectedPack.slug,
        };
        let response = await this.$http.get(
          "trainings-pack/get-certified-users" + _buildQuery(params)
        );
        if (response.data) {
          this.users = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erreur",
          text: error.response.data.message
            ? error.response.data.message
            : "Veuillez contacter l'administrateur",
          color: "danger",
          position: "top-right",
        });
      }
    },
    async loadPackTranings(page) {
      try {
        // this.$vs.loading();
        let response = await this.$http.get(
          "trainings-pack/index" + _buildQuery({ paginate: 2 })
        );
        if (response.data) {
          this.$vs.loading.close();
          this.pack_trainings = response.data;
          let beginner_pack = response.data.filter(function (pack) {
            return pack.is_beginner_pack == "1";
          });

          this.selectedPack = beginner_pack[0];
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erreur",
          text: error.response.data.message
            ? error.response.data.message
            : "Veuillez contacter l'administrateur",
          color: "danger",
          position: "top-right",
        });
      }
    },
  },
  mounted() {
    if (this.hasAccess) {
      this.loadPackTranings();
    }
  },
};
</script>

<style lang="scss">
.activate-button {
  background: white !important;
  border: 1px solid black;
  border-radius: 25px;
  font-size: 0.8em !important;
}
.export-button {
  background: #ffcc00 !important;
  border-radius: 25px;
  font-size: 0.8em !important;
}

.activate-action {
  color: #ffcc00;
}

.no-active {
  color: #b5453c;
}

.is-active {
  color: #39a44a;
}

#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
    }

    .vs-table {
      font-size: 0.8rem;
      width: 100% !important;
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      // padding: 0 0.5rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          font-size: 14px;

          &:first-child {
            border-top-left-radius: 0.1rem;
            border-bottom-left-radius: 0.1rem;
          }
          &:last-child {
            border-top-right-radius: 0.1rem;
            border-bottom-right-radius: 0.1rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          // text-transform: uppercase;
          font-weight: 600;
          color: black;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: right;
    }
  }
}

.stats-block {
  font-size: 26px;
  color: #000000;
}

.left-card-container {
  display: flex;
  flex-direction: row;
}

.flex-item-left {
  flex: 60% !important;
}

.flex-item-right {
  flex: 40% !important;
}

/* Responsive layout - makes a one column-layout instead of two-column layout */
@media (max-width: 800px) {
  .left-card-container {
    flex-direction: column;
  }
}

.spinner {
  animation: rotate 2s linear infinite;
  z-index: 2;
  position: absolute;
  // top: 50%;
  left: 99.5%;
  margin: -25px 0 0 -25px;
  width: 27px;
  height: 50px;

  & .path {
    stroke: hsl(210, 70, 75);
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>